import { render, staticRenderFns } from "./AddCharges.vue?vue&type=template&id=30405a1e"
import script from "./AddCharges.vue?vue&type=script&lang=js"
export * from "./AddCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports